export default [
    { type: 0, name: 'Cash' },
    { type: 1, name: 'Credit Card' },
    { type: 2, name: 'Cheque' },
    { type: 3, name: 'Voucher' },
    { type: 4, name: 'Others' },
    { type: 6, name: 'Mobility One' },
    { type: 7, name: 'MPay' },
    { type: 8, name: 'Adaptis' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/payment-types.js